import { versaoSistemaService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const versaoSistemaAction = {
    getVersaoSistema,
    getVersaoSistemaById,
    onChangeProps,
    createVersaoSistema,
    editVersaoSistemaInfo,
    deleteVersaoSistemaById,
    clear
};

function getVersaoSistema(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'versaoSistema';
        versaoSistemaService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeVersaoSistemaList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function editVersaoSistemaInfo(id, payload) {
    return dispatch => {
        let apiEndpoint = 'versaoSistema/' + id;
        versaoSistemaService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    alerts.success(ret.message, '/versoesSistemas');

                } else {
                    alerts.warning(response.request.responseText);
                }
            })
    }
}

function getVersaoSistemaById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'versaoSistema/' + id;
        versaoSistemaService.get(apiEndpoint)
            .then((response) => {
                dispatch(editVersaoSistemaDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function createVersaoSistema(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'versaoSistema/';
        versaoSistemaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response != undefined && response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    dispatch(clear());
                    alerts.success(ret.message, '/versoesSistemas');
                } else {
                    alerts.warning(response.data.Message);
                }
            })
    }
}

function deleteVersaoSistemaById(id) {
    return dispatch => {
        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {
                    let apiEndpoint = 'VersaoSistema/' + id;
                    versaoSistemaService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteVersaoSistemaDetails());
                                dispatch(getVersaoSistema());
                                alerts.success(ret.message);
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })
                }
            });
    };
}

function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}

export function changeVersaoSistemaList(versaoSistema) {
    return {
        type: "FETCHED_ALL_VERSAO_SISTEMA",
        versaoSistema
    }
}

export function clear() {
    return {
        type: "VERSAO_SISTEMA_CLEAR"
    };
}

export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}

export function editVersaoSistemaDetails(versaoSistema) {
    return {
        type: "VERSAO_SISTEMA_DETAIL",
        id: versaoSistema.id,
        codigo: versaoSistema.codigo,
        sistema: versaoSistema.sistema,
        data_cadastro: versaoSistema.data_cadastro,
        usuario_cadastro: versaoSistema.usuario_cadastro,
        data_exclusao: versaoSistema.data_exclusao,
        usuario_exclusao: versaoSistema.usuario_exclusao
    }
}

export function updatedUserInfo() {
    return {
        type: "VERSAO_SISTEMA_UPDATED"
    }
}

export function createUserInfo() {
    return {
        type: "VERSAO_SISTEMA_CREATED_SUCCESSFULLY"
    }
}

export function deleteVersaoSistemaDetails() {
    return {
        type: "DELETED_VERSAO_SISTEMA_DETAILS"
    }
}